import { formatPrice } from '../formatting';
import getSubscriptionIntervalWithSlash from '../formatting/getSubscriptionIntervalWithSlash';

export default function getPriceLabel(
  { amount = 0, currency = 'usd', interval = '', intervalCount = 0, type = '' },
  locale = 'en-US',
) {
  const formattedPrice = formatPrice({
    amount: amount,
    currency: currency,
    locale,
    style: 'currency',
  });

  if (type === 'subscription') {
    return `${formattedPrice} ${getSubscriptionIntervalWithSlash(
      interval,
      intervalCount,
    )}`;
  }

  return formattedPrice;
}
